module.exports = __webpack_public_path__ + "img/pdf1.4e6b0608.png";